var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import styled from "styled-components";
import media from "../../global/media";
import { Card } from "../../Layout";
var StyledCard = styled(Card)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), media.phoneLandscape(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-radius: 0;\n  "], ["\n    border-radius: 0;\n  "]))));
var AccountSideBar = /** @class */ (function (_super) {
    __extends(AccountSideBar, _super);
    function AccountSideBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountSideBar.prototype.render = function () {
        return (React.createElement(StyledCard, __assign({ tiny: true, noBorder: true }, this.props)));
    };
    return AccountSideBar;
}(Component));
export default AccountSideBar;
var templateObject_1, templateObject_2;
